var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showData.isShow)?_c('div',{staticClass:"version-guide",on:{"click":_vm.hideGuide}},[_c('img',{attrs:{"src":_vm.$t('改版指引图片')}}),_c('Button',{on:{"click":_vm.hideGuide}},[_vm._v(_vm._s(_vm.$t('我知道啦')))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }